import React from "react";
import { GET, DELETE } from '../../../utils/AxiosRequest'

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle'

import { FactureViewer } from "../FactureViewer";
import { useTheme } from "@mui/material";

export const DeleteFacture = (props) => {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const facture = React.useRef(null);
	const [factureList, setFactureList] = React.useState([]);
	const [factureId, setFactureId] = React.useState(0);

	function ChangeFactureId(event){
		setFactureId(event.target.value);
	};

	function HandleOpen(){
		return GetAllFactures()
		.then(data => {
			setFactureList(data);
			setOpen(true);
		})
	}

	function HandleClose(save){
		var id = (save) ? factureList[factureId].id : 0;
		setOpen(false)
		setFactureId(0);
		if(save){
			return DeleteFactureInDb(id)
		}
	}

	//#region AXIOS REQUESTS
	function GetAllFactures() { return GET("factures/getAllFactures") }
	function DeleteFactureInDb(id) { return DELETE("factures/deleteFacture", {id: id}) }


	//#endregion

	return (
		<div>
			<Button fullWidth variant="contained" onClick={() => HandleOpen()}>Choisir une facture à supprimer</Button>
			<Dialog fullWidth maxWidth="md" open={open} onClose={() => HandleClose(false)}>
				<DialogTitle color={theme.palette.text.primary}>Choisir une facture à supprimer</DialogTitle>
				<DialogContent>
					<Stack spacing={2} direction="column">
						<TextField select label="Facture à supprimer" variant="standard" value={factureId} onChange={ChangeFactureId}>
							{factureList.map((facture, i) => (
								<MenuItem value={i} key={facture.id}>{facture.nom + " - " + facture.reference}</MenuItem>
							))}
						</TextField>
					</Stack>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => HandleClose(true)} color="error">Supprimer</Button>
					<Button onClick={() => HandleClose(false)}>Retour</Button>
				</DialogActions>
			</Dialog>
			<FactureViewer ref={facture}/>
		</div>
	)
}

